export default (price) => {
    let currency = window?.APP_SETTINGS?.portalSettings?.CURRENCY_SYMBOL || "";
    return `${price}${currency}`;
}